import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import { LABELS, WARNINGS, TITLES, SUCCESS, ERRORS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { GEO_APIs } from "../../../apihandlers/geography";
import { PRODUCT_APIs } from "apihandlers/product";

const Product = (props: any) => {
  const { setDashMenu } = props;

  const mainCategRef: any = useRef(null);
  const subCategRef: any = useRef(null);
  const categoryRef: any = useRef(null);
  const gramsRef: any = useRef(null);
  const taxRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [mainCategs, setMainCategs] = useState<any>(null);
  const [subCategs, setSubCategs] = useState<any>(null);
  const [categories, setCategories] = useState<any>(null);
  const [taxes, setTaxes] = useState<any>(null);
  const [grams, setGrams] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getProductTypeCategory();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await PRODUCT_APIs.getProducts(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getRegions:", error);
    }
  };

  const getProductTypeCategory = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getProductTypeCategory(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setCategories(list);
        getProductSubCategory();
      }
    });
  };
  const getProductSubCategory = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getProductSubCategory(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setSubCategs(list);
        getProductMainCategory();
      }
    });
  };
  const getProductMainCategory = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getProductMainCategory(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setMainCategs(list);
        getGramsMaster();
      }
    });
  };
  const getGramsMaster = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getGramsMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setGrams(list);
        getTaxMaster();
      }
    });
  };
  const getTaxMaster = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getTaxMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.taxName,
          };
        });
        setTaxes(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      key: "productName",
      name: LABELS.PRODUCT_NAME,
      width: "20%",
    },
    {
      key: "typeCategory",
      name: LABELS.CATEGORY,
      width: "20%",
    },
    {
      key: "grams",
      name: LABELS.GRAMS,
      width: "20%",
    },
    {
      key: "taxStructure",
      name: LABELS.TAX,
      width: "10%",
    },
    {
      key: "price",
      name: LABELS.PRICE,
      width: "10%",
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "10%",
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRegion = () => {
    const productName = (
      document.getElementById("productName") as HTMLInputElement
    ).value.trim();
    const alias = (
      document.getElementById("aliasName") as HTMLInputElement
    ).value.trim();
    const mainCategoryId = mainCategRef.current.selectedValue.id;
    const subCategoryId = subCategRef.current.selectedValue.id;
    const typeCategoryId = categoryRef.current.selectedValue.id;
    const gramsId = gramsRef.current.selectedValue.id;
    const taxStructureId = taxRef.current.selectedValue.id;
    const price = (
      document.getElementById("price") as HTMLInputElement
    ).value.trim();
    const mrp = (
      document.getElementById("mrp") as HTMLInputElement
    ).value.trim();
    const minPrice = (
      document.getElementById("minPrice") as HTMLInputElement
    ).value.trim();
    const sortingOrder = (
      document.getElementById("sortingOrder") as HTMLInputElement
    ).value.trim();
    const hsnCode = (
      document.getElementById("hsnCode") as HTMLInputElement
    ).value.trim();
    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";
    // Validations
    if (!productName) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    if (!alias) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      productName: productName,
      aliasName: alias,
      branchId: 7,
      gramsId: gramsId,
      mainCategoryId: mainCategoryId,
      subCategoryId: subCategoryId,
      typeCategoryId: typeCategoryId,
      taxStructureId: taxStructureId,
      price: price,
      mrp: mrp,
      minPrice: minPrice,
      sortingOrder: sortingOrder,
      hsnCode: hsnCode,
      activeStatus: selectBtnValue.toString(),
      imageId: 2,
    };
    console.log("args", args);
    setIsSubmit(true);
    PRODUCT_APIs.manageProduct(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.PRODUCT}</li>
        </ul>
        <h4>{TITLES.PRODUCT}</h4>
        {/* <p>{SUB_TITLES.PRODUCT}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.PRODUCT}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.PRODUCT + ": " + selectedRow.productName
              : "Add New " + LABELS.PRODUCT
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="formGroup">
            <TxtRow
              id={"productName"}
              type={"text"}
              label={LABELS.PRODUCT_NAME}
              required={true}
              defaultValue={selectedRow.productName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"aliasName"}
              type={"text"}
              label={LABELS.ALIAS}
              // required={true}
              defaultValue={selectedRow.aliasName}
              disabled={isSubmit}
            />
          </div>
          <div className="flexRowJustify">
            <div className="formGroup  width30">
              <label>{LABELS.MAIN_CATEG}</label>
              <AutoComplete
                list={mainCategs}
                childRef={mainCategRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.mainCategoryId,
                        label: selectedRow.mainCategory,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <label>{LABELS.SUB_CATEG}</label>
              <AutoComplete
                list={subCategs}
                childRef={subCategRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.subCategoryId,
                        label: selectedRow.subCategory,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.CATEGORY}</label>
              <AutoComplete
                list={categories}
                childRef={categoryRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.typeCategoryId,
                        label: selectedRow.typeCategory,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>{LABELS.GRAMS}</label>
              <AutoComplete
                list={grams}
                childRef={gramsRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.gramId,
                        label: selectedRow.grams,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.TAX}</label>
              <AutoComplete
                list={taxes}
                childRef={taxRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.taxId,
                        label: selectedRow.taxStructure,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"hsnCode"}
                type={"text"}
                label={LABELS.HSN_CODE}
                required={true}
                defaultValue={selectedRow.hsnCode}
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width30">
              <TxtRow
                id={"mrp"}
                type={"number"}
                label={LABELS.MRP}
                required={true}
                defaultValue={selectedRow.mrp}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"price"}
                type={"number"}
                label={LABELS.PRICE}
                required={true}
                defaultValue={selectedRow.price}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"minPrice"}
                type={"number"}
                label={LABELS.MIN_PRISE}
                required={true}
                defaultValue={selectedRow.minPrice}
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width30">
              <TxtRow
                id={"sortingOrder"}
                type={"number"}
                label={LABELS.SORTING_ORDER}
                required={true}
                defaultValue={selectedRow.sortingOrder}
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="formGroup">
            <label>
              {LABELS.STATUS} {<span className="red">*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup submitBtnWrapper">
            <div className="width45 flexRowJustify">
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRegion}
              />
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.DIM_DARK_GRAY}
                onClick={() => setManageDialog(false)}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Product);
